import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { PackageCheck, Gauge, AlertTriangle } from "lucide-react";

export default function RecapCard() {
  const [recap, setRecap] = useState(null);
  useEffect(() => { api.get("/admin/run-recap").then((r) => setRecap(r.data)).catch(() => {}); }, []);
  if (!recap) return null;
  return (
    <Card className="mt-4 border-kilted-green/20" data-testid="admin-recap-card">
      <CardContent className="pt-5">
        <div className="mb-3 flex items-center justify-between">
          <p className="text-xs font-semibold uppercase tracking-widest text-kilted-gold">Today's run · {recap.date}</p>
          <p className="text-xs text-muted-foreground">Nightly email goes out 7pm</p>
        </div>
        <div className="grid grid-cols-3 gap-3">
          <div className="rounded-lg bg-kilted-green/5 p-3">
            <p className="flex items-center gap-1.5 text-xs text-muted-foreground"><PackageCheck className="h-3.5 w-3.5 text-kilted-green" /> Stops completed</p>
            <p className="font-heading text-2xl font-extrabold text-kilted-green" data-testid="recap-stops">{recap.stops_completed}</p>
          </div>
          <div className="rounded-lg bg-kilted-green/5 p-3">
            <p className="flex items-center gap-1.5 text-xs text-muted-foreground"><Gauge className="h-3.5 w-3.5 text-kilted-green" /> Km driven</p>
            <p className="font-heading text-2xl font-extrabold text-kilted-green" data-testid="recap-km">{recap.km_driven}</p>
          </div>
          <div className={`rounded-lg p-3 ${recap.missed.length ? "bg-amber-50" : "bg-kilted-green/5"}`}>
            <p className="flex items-center gap-1.5 text-xs text-muted-foreground"><AlertTriangle className={`h-3.5 w-3.5 ${recap.missed.length ? "text-amber-600" : "text-kilted-green"}`} /> Still open</p>
            <p className={`font-heading text-2xl font-extrabold ${recap.missed.length ? "text-amber-700" : "text-kilted-green"}`} data-testid="recap-open">{recap.missed.length}</p>
          </div>
        </div>
        {Object.keys(recap.by_driver).length > 0 && (
          <div className="mt-3 flex flex-wrap gap-1.5" data-testid="recap-drivers">
            {Object.entries(recap.by_driver).map(([name, d]) => (
              <span key={name} className="rounded-full border border-kilted-green/30 bg-white px-2.5 py-0.5 text-xs">
                <span className="font-medium text-kilted-green">{name}</span> · {d.stops} stops · {d.km} km
              </span>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
